import React from 'react';
import {Container, Row, Col} from "react-bootstrap";


function Readybuild(props) {
    return (
        <section className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="SAP Optimize">
                            <h2>Optimize Your Business With Our SAP Consultation</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p> Book your free discovery call today to learn how your business can achieve exponential
                            growth with TekRevol's SAP consultation services.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Readybuild;